import React from 'react';
import Modal from '@core/components/Modal/Modal';
import { MOBILE_SLIDE_UP, MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';
import UseModal from 'hooks/use-modal';
import InterestsForm from 'components/pages/settings/interestsform/InterestsForm';

import { Edit } from 'iconsax-react';


import classes from './InterestArea.module.scss';

const InterestArea = ({ data, refetch, toast }) => {

    const {
        showModal: showInterestsModal,
        destroyModal: destoryInterestsModal,
        show: showInterests
    } = UseModal();
    return (
        <>
            <div className={classes['wrapper']}>
                {data && (
                    <>
                        <div className='d-flex justify-content-between align-items-center'>
                            <p className="mb-2 mb-md-0">Areas of Interest</p>
                            {data.data.is_verified && (
                                <Edit role="button" onClick={() => showInterestsModal()} size={24} color='#BB3A90' variant='TwoTone' />
                            )}
                        </div>
                        <div className={classes['interests-wrapper']}>
                            {Array.isArray(data?.data.interests) && data.data.interests.length > 0
                                ? data.data.interests.map((interest, idx) => (
                                    <div key={idx}>{interest}</div>
                                ))
                                : '-'}
                        </div>
                    </>
                )}
            </div>

            <Modal
                show={showInterests}
                closeHandler={destoryInterestsModal}
                type={MOBILE_SLIDE_UP}>
                <InterestsForm closeHandler={destoryInterestsModal} refetchHandler={refetch} toast={toast} />
            </Modal>

        </>
    );
};

export default InterestArea;